import request from "./clientsApi";
import { API_ROUTES } from "../config/baseURL";

export const apiGetSubGrupos = async (idSubGrupo, idgrupo) => {
  const rs = await request(API_ROUTES.getSubGroups(idSubGrupo, idgrupo), {
    method: "GET",
  });
  return rs.json();
};

export const apiGetSubGroupById = async (idsubgrupo) => {
  const res = await request(API_ROUTES.getSubGroups(idsubgrupo, ""), {
    method: "GET",
  });
  return res.json();
};

export const apiSaveSubGroup = async (form) => {
  const isUpdate = !!form.id;
  const res = await request(API_ROUTES.saveSubGroup, {
    method: isUpdate ? "PUT" : "POST",
    body: JSON.stringify(form),
  });

  return res.json();
};
